<div class="modal" [class.modal--with-close]="isVisibleClose" [ngClass]="additionalClassName">
    <div class="modal-body">
        <i *ngIf="isVisibleClose" class="modal-close" (click)="close()"></i>
        <ng-content></ng-content>
    </div>
</div>
<div class="modal-overlay" (click)="close()"></div>
